/**
 * Copyright 2025 MadeByTatwa LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Base detector interface and utilities
 */
import type { DetectorResult } from '../types/index.js';

/**
 * Base interface for all detectors
 */
export interface Detector {
  name: string;
  detect(cwd: string): Promise<DetectorResult>;
}

/**
 * Helper to create a detector result
 */
export const createDetectorResult = (
  detectorName: string,
  confidence: number,
  plan?: Partial<DetectorResult['plan']>
): DetectorResult => {
  return {
    detectorName,
    confidence,
    plan,
  };
};

